import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';
import { ProductService } from 'src/app/core/services/product.service';
declare var $: any;  

@Component({
  selector: 'app-view-catalogue',
  templateUrl: './view-catalogue.component.html',
  styleUrls: ['./view-catalogue.component.scss']
})
export class ViewCatalogueComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private ccs: CommonCommunicationService,
    private router: Router
  ) { }

  viewId: any
  activeShopId: any
  productList: any
  catalogueData: any
  pageNo: any = '1'
  loopArray: any = []
  catalogueProdList: any[] = []

  ngOnInit(): void {

    $(window).ready(function() {
      $('.pages').turn({
      duration: 1500,
      width: 900,
      height: 600,
     autoCenter: true,
     turnCorners: "bl,br",
        elevation: 300,
      });
    });
  
    this.route.queryParams.subscribe((params: any) => {
      if (params.viewId) {
        for (let i = 0; i < params.page; i++) {
          this.loopArray.push(i)
        }
        this.viewId = params.viewId
        this.getCatalogueById()
      }
    })
    this.ccs.getActiveShopId().subscribe(res => {
      if (res) {
        this.activeShopId = res
        // this.getProductList()
      }
    })
  }

  getProductList() {
    let payload: any = {
      "shopId": this.activeShopId,
    }
    this.productService.getProductList(payload, 1, 100).subscribe(res => {
      this.productList = res.result.data
      for (let j = 0; j < this.catalogueData.cataloguePageList.length; j++) {
        this.catalogueProdList.push({ productInfo: [] })
        for (let k = 0; k < this.catalogueData.cataloguePageList[j].productId.length; k++) {
          let prod = this.catalogueData.cataloguePageList[j].productId[k]
          for (let i = 0; i < this.productList.length; i++) {
            if (prod === this.productList[i]._id) {
              this.catalogueProdList[j].productInfo.push(this.productList[i])
            }
          }
        }

      }

    })
  }

  getCatalogueById() {
    this.productService.getCatalogueById(this.viewId).subscribe(res => {
      this.catalogueData = res
      this.getProductList()
      // this.loopArray.push("1")
    })
  }

  viewProduct(id:any){
    this.router.navigate(['/view-product'],{queryParams: {viewId:id}})
  }

}
